module.exports = __webpack_public_path__ + "static/media/flying_ceilin_2.3d28e74c.jpeg";